import PartnerBankData = App.Data.PartnerBank.PartnerBankData
import PartnerBankFinancingProfileData = App.Data.PartnerBank.PartnerBankFinancingProfileData

type Decision = App.Enums.PartnerBankDecision

/**
 * Maps a bank decision (yes / no / case_by_case) to a PrimeVue Tag severity.
 */
export const decisionSeverity = (decision?: Decision | null): 'success' | 'danger' | 'warn' | 'secondary' => {
  switch (decision) {
    case 'yes':
      return 'success'
    case 'no':
      return 'danger'
    case 'case_by_case':
      return 'warn'
    default:
      return 'secondary'
  }
}

/**
 * The financing profile is exposed as a has-one relation, but the generated type
 * still describes it as an array. Normalize both shapes to a single object.
 */
export const financingProfile = (bank: PartnerBankData): PartnerBankFinancingProfileData | null => {
  const profile = bank.financing_profile
  if (!profile) return null
  return Array.isArray(profile) ? (profile[0] ?? null) : profile
}
